import { useConfig } from "@/context/ConfigContext";
import { useCallback, useEffect, useState } from "react";

export function useProductTestimonials(options = {}) {
  const { productUuid, enabled = true } = options;
  const { configData } = useConfig();

  const [testimonials, setTestimonials] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTestimonials = useCallback(async () => {
    if (!productUuid || !configData?.team_id) return;

    try {
      setLoading(true);
      setError(null);

      const teamId = configData.team_id;
      const proxyUrl = `/api/products?team_id=${teamId}&type=testimoni&product_id=${productUuid}`;

      const response = await fetch(proxyUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        cache: "no-cache",
      });

      if (!response.ok) {
        let errorData;
        try {
          errorData = await response.json();
        } catch {
          errorData = { message: response.statusText };
        }
        throw new Error(errorData.message || response.statusText);
      }

      const data = await response.json();

      if (Array.isArray(data.data)) {
        setTestimonials(data.data);
        setMeta(data.meta || null);
      } else {
        setTestimonials([]);
        setMeta(null);
      }
    } catch (err) {
      setError(err.message || "Gagal mengambil testimoni");
    } finally {
      setLoading(false);
    }
  }, [configData?.team_id, productUuid]);

  useEffect(() => {
    if (!enabled || !productUuid || !configData?.team_id) return;
    fetchTestimonials();
  }, [enabled, fetchTestimonials, productUuid, configData?.team_id]);

  return {
    testimonials,
    meta,
    loading,
    error,
    refetch: fetchTestimonials,
  };
}

